function process(str) {
  const div = document.createElement('div');
  div.innerHTML = str.trim();

  return format(div, 0).innerHTML;
}

function format(node, level) {
  const indentBefore = new Array(level++ + 1).join('  ');
  const indentAfter = new Array(level - 1).join('  ');
  let textNode;

  for (var i = 0; i < node.children.length; i++) {
    textNode = document.createTextNode('\n' + indentBefore);
    node.insertBefore(textNode, node.children[i]);

    format(node.children[i], level);

    if (node.lastElementChild === node.children[i]) {
      textNode = document.createTextNode('\n' + indentAfter);
      node.appendChild(textNode);
    }
  }

  return node;
}

const numberRanges = [
  { divider: 1e12, suffix: 'T' },
  { divider: 1e9, suffix: 'B' },
  { divider: 1e6, suffix: 'M' },
  { divider: 1e3, suffix: 'k' },
];

export const formatNumberWithSuffix = (number, alwaysFixed = false, digits = 1) => {
  const parsedNumber = +number;

  if (!alwaysFixed && (number < 1000)) {
    return parsedNumber;
  }

  for (let i = 0; i < numberRanges.length; i++) {
    if (parsedNumber >= numberRanges[i].divider) {
      return (parsedNumber / numberRanges[i].divider).toFixed(digits).toString() + numberRanges[i].suffix;
    }
  }
  return parsedNumber.toFixed(digits).toString();
};

export default process;
